import { Modal, ModalCloseButton, ModalContent, ModalHeader, ModalTitle } from '@/design-system/modal/modal';
import { ComponentProps } from 'react';
import { KiidAcceptanceModalContent } from './kiid-acceptance-modal-content';

type KiidAcceptanceModalProps = {
  isOpen: boolean;
} & ComponentProps<typeof KiidAcceptanceModalContent>;

export const KiidAcceptanceModal = (props: KiidAcceptanceModalProps) => {
  const { isOpen, onClose, ...rest } = props;

  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent aria-describedby={undefined} className="h-max max-w-[515px] overflow-y-auto p-6">
        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <ModalHeader>
          <ModalTitle className="text-lg leading-[18px] font-semibold text-foreground">Review and confirm</ModalTitle>
        </ModalHeader>

        <KiidAcceptanceModalContent {...rest} onClose={onClose} />
      </ModalContent>
    </Modal>
  );
};
